import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/** @module others/rfcPreUploadUi */
import $ from "jquery";
import hooks from "../util/hooks";
import rmlOpts from "rmlopts";
import createFolderSelector from "../components/FolderSelector";
import store from "../store";
/**
 * Load data to a dropdown or show label that the folder is inherited from the AppTree.
 * This RFC is placed in the upload UI where you can select your files.
 *
 * @function preUploadUi
 * @listens module:util/hooks#wprfc/$function
 */

hooks.register("wprfc/preUploadUi", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var compatView, attachmentsBrowser, span;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            compatView = !!$(this).parent(".rml-compat-preUploadUi").length;
            attachmentsBrowser = $(this).parents(".attachments-browser"); // Fallback to main media library page

            compatView && !attachmentsBrowser.length && (attachmentsBrowser = $(".attachments-browser"));

            if (attachmentsBrowser.length && !compatView) {
              $(this).parent().hide().prev().html(rmlOpts.others.lang.uploaderUsesLeftTree);
            } else {
              span = $("<span/>").addClass(compatView ? undefined : "attachments-filter-preUploadUi").insertAfter($(this)).get(0);
              createFolderSelector(span, $(this).get(0), Object.assign(data, {
                style: {
                  maxWidth: 400
                },
                // When in compat view raise the change event manually so it is saved
                onSelect: compatView && function (node, input) {
                  var _attachmentsBrowser$d;

                  (_attachmentsBrowser$d = attachmentsBrowser.data("backboneView")) === null || _attachmentsBrowser$d === void 0 ? void 0 : _attachmentsBrowser$d.controller.once("attachment:compat:ready", function () {
                    return store.fetchCounts();
                  });
                  $(input).trigger("change");
                }
              }));
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());